<common-activation id="activation-component">
</common-activation>
